import { gql } from "@apollo/client";

export const PRODUCT_SEARCH = gql`
  query productSearch(
    $product_code: [String!]
    $geo: GeoLocationInput
    $name: String
    $limit: Int
  ) {
    product_search(product_code: $product_code, geo: $geo, name: $name) {
      id
      brand {
        id
        logo {
          id
          thumbnail
        }
        name
      }
      distance
      location {
        latitude
        longitude
      }
      name
      prices {
        price
        gross_price
        last_updated
        taxes {
          id
          name
          rate
        }
        history(limit: $limit) {
          points {
            price
            gross_price
            time
          }
          trend
        }
        price_type_id
      }
      product_code
      store {
        id
        name
        brand {
          id
          logo {
            id
            thumbnail
            url
          }
        }
        recent_price_change
        integrations {
          integration_id
          integration_type
        }
        address {
          location {
            latitude
            longitude
          }
          door_number
          building_name
          line1
          line2
          city_town
          country
          postcode
          county
        }
      }
    }
  }
`;

export const UPDATE_PRICE = gql`
  mutation update_price(
    $product_id: UUID!
    $prices: [ProductPriceInput!]!
    $limit: Int
  ) {
    update_price(product_id: $product_id, prices: $prices) {
      id
      name
      product_code
      prices {
        gross_price
        price
        last_updated
        taxes {
          id
          name
          rate
        }
        history(limit: $limit) {
          points {
            gross_price
            price
            time
          }
          trend
        }
        price_type_id
      }
    }
  }
`;

export const UPDATE_PRODUCTS = gql`
  mutation update_products($products: [UpdateProductInput!]!) {
    update_products(products: $products) {
      id
      name
      product_code
    }
  }
`;

export const RECENT_PRICE_CHANGE = gql`
  query priceChange {
    recent_price_change
  }
`;

export const MARGIN_HISTORY = gql`
  query margin_history(
    $product_ids: [UUID]!
    $from: NaiveDateTime!
    $to: NaiveDateTime!
  ) {
    margin_history(product_ids: $product_ids, from: $from, to: $to) {
      product {
        id
        name
        product_code
      }
      margins {
        buy_price
        sell_price
        absolute_margin
        percentage_margin
        time
      }
    }
  }
`;

export const SOLD_STOCKS = gql`
  query sold_stocks(
    $product_ids: [UUID]!
    $from: NaiveDateTime!
    $to: NaiveDateTime!
    $fromCompare: NaiveDateTime!
    $toCompare: NaiveDateTime!
    $period: Int!
  ) {
    main_data: sold_stocks(
      product_ids: $product_ids
      from: $from
      to: $to
      period: $period
    ) {
      product {
        id
        name
        product_code
      }
      sold_stocks {
        prices {
          gross_price
          last_updated
        }
        volumes {
          from
          to
          sold_stocks
          closing_volumes
        }
      }
    }

    compare_data: sold_stocks(
      product_ids: $product_ids
      from: $fromCompare
      to: $toCompare
      period: $period
    ) {
      product {
        id
      }
      sold_stocks {
        prices {
          gross_price
          last_updated
        }
        volumes {
          from
          to
          sold_stocks
          closing_volumes
        }
      }
    }
  }
`;

export const STOCK_DEFICIT = gql`
  query stock_deficit(
    $product_ids: [UUID]!
    $from: NaiveDateTime!
    $to: NaiveDateTime!
    $period: Int!
  ) {
    stock_deficit(
      product_ids: $product_ids
      from: $from
      to: $to
      period: $period
    ) {
      from
      to
      data {
        deficit
        deficit_to_date
        product {
          id
          name
        }
      }
    }
  }
`;
